import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { NavLink } from 'react-router-dom';

const TrialBanner = () => {
  const { currentUser: user } = useAuth();
  
  // Guardia de Seguridad
  if (!user || !user.cuenta) {
    return null;
  }

  const { en_periodo_prueba, dias_restantes_prueba, flow_subscription_id, subscription_status } = user.cuenta;

  // LÓGICA CORREGIDA:
  // NO mostrar el banner si:
  // 1. El usuario tiene flow_subscription_id (ya pagó/registró tarjeta en Flow)
  // 2. El estado de pago es 'activo'
  // 3. El estado de suscripción es 'active' (no trial)
  // 4. No está en periodo de prueba
  
  // Caso especial: Usuario Inactivo (Modo Prueba Limitada)
  if (subscription_status === 'inactive') {
    return (
      <div className="bg-blue-50 border border-blue-200 rounded-lg shadow-md m-4 p-4 flex flex-col sm:flex-row items-center justify-between gap-4 relative z-40">
        <div className="flex items-center gap-3">
          <span className="text-2xl">🚀</span>
          <div>
            <p className="text-blue-800 font-medium">
              Modo Prueba: Tienes 1 creación gratis disponible
            </p>
            <p className="text-blue-600 text-sm">
              Suscríbete para desbloquear todo el potencial de tu clínica.
            </p>
          </div>
        </div>
        
        <NavLink 
          to="/app/suscripcion" 
          className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition-colors shadow-sm whitespace-nowrap"
        >
          Activar Ahora
        </NavLink>
      </div>
    );
  }

  // Solo mostrar si está en trial GRATUITO (sin haber registrado pago)
  const hasPaymentMethod = !!flow_subscription_id;
  const isPaidSubscription = subscription_status === 'active';
  
  if (!en_periodo_prueba || hasPaymentMethod || isPaidSubscription) {
    return null;
  }

  return (
    <div className="bg-orange-50 border border-orange-200 rounded-lg shadow-md m-4 p-4 flex flex-col sm:flex-row items-center justify-between gap-4 relative z-40">
      <div className="flex items-center gap-3">
        <span className="text-2xl">⏳</span>
        <div>
          <p className="text-orange-800 font-medium">
            Periodo de prueba activo
          </p>
          <p className="text-orange-600 text-sm">
            Te quedan <strong>{dias_restantes_prueba} días</strong> de acceso gratuito.
          </p>
        </div>
      </div>
      
      <NavLink 
        to="/app/suscripcion" 
        className="bg-orange-500 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-orange-600 transition-colors shadow-sm whitespace-nowrap"
      >
        Hazte Premium
      </NavLink>
    </div>
  );
};

export default TrialBanner;
